import React from 'react';
import { Box } from '@mui/material';
import { useReducedMotion } from '../hooks/useReducedMotion';

const LiveDot: React.FC = () => {
  const reduceMotion = useReducedMotion();

  return (
    <Box
      sx={{
        width: 8,
        height: 8,
        borderRadius: '50%',
        backgroundColor: '#4caf50',
        display: 'inline-block',
        flexShrink: 0,
        ...(!reduceMotion && {
          animation: 'livePulse 1.5s ease-in-out infinite',
          '@keyframes livePulse': {
            '0%, 100%': { opacity: 1, transform: 'scale(1)' },
            '50%': { opacity: 0.4, transform: 'scale(0.85)' },
          },
        }),
      }}
    />
  );
};

export default LiveDot;
